import { faCheckCircle, faRefresh, faStar, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Col, Row, Stack } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { deleteTask, patchTask } from "../../../../services/httpClient";
import { Task } from "../../../../types/task";
import { Tooltip } from "react-tooltip";

interface TaskItemState {
  task: Task;
  goalArchived: boolean | number | undefined;
  goalCompleted: boolean | number | undefined;
  fetchGoals?: any;
  goalId?: string;
  setShowToast?: any;
  setToastText?: any;
  setToastBody?: any;
  inNextTasks?: boolean;
  myCase: boolean | undefined;
}

const TaskItem = ({
  task,
  goalArchived,
  goalCompleted,
  fetchGoals,
  goalId,
  setShowToast,
  setToastText,
  setToastBody,
  inNextTasks = false,
  myCase,
}: TaskItemState) => {
  const { id } = useParams();
  const [next, setNext] = useState<boolean>();
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [taskToDelete, setTaskToDelete] = useState<any>();

  useEffect(() => {
    setNext(task.is_next ? true : false);
  }, []);

  const handleCompletedClick = (taskId: any) => {
    if (goalArchived !== 1 && goalCompleted !== 1) {
      //if completed image marked true then update completed to true and reviewed to true
      //if completed image marked false then leave completed and make reviewed false
      var taskChanges = {};
      if (task.is_cm_reviewed !== 1) {
        taskChanges = {
          is_cm_reviewed: true,
          is_completed: task.is_completed === 1 ? true : false,
        };
      } else {
        taskChanges = {
          is_cm_reviewed: false,
          is_completed: false,
        };
      }

      patchTask(taskChanges, id, goalId, taskId).then((res: any) => {
        fetchGoals();
        setShowToast(true);
        if (task.is_cm_reviewed !== 1) {
          setToastText("Task Completed");
        } else {
          setToastText("Task Not Completed");
        }
        setToastBody(task.name);
      });
    }
  };

  const handleNextClick = (taskId: any) => {
    var toastText = "";
    var taskChanges = {};
    if (next === true) {
      toastText = "Next Task Removed";
      taskChanges = {
        is_next: false,
        is_completed: false,
      };
    } else {
      toastText = "Next Task Created";
      taskChanges = {
        is_next: true,
      };
    }

    const currentNext = next;
    setNext(!currentNext);

    patchTask(taskChanges, id, goalId, taskId)
      .then((res: any) => {
        fetchGoals();
        setShowToast(true);
        setToastText(toastText);
        setToastBody(task.name);
      })
      .catch((err: any) => {
        setNext(currentNext);
      });
  };

  const handleDeleteClick = (taskId: any) => {
    if (!task.is_completed) {
      deleteTask(id, goalId, taskId).then((res: any) => {
        fetchGoals();
        setShowToast(true);
        setToastText("Task Deleted");
        setToastBody(task.name);
      });
    }
  };

  const handleReturnClick = (taskId: any) => {
    const taskChanges = {
      is_next: true,
      is_completed: false,
    };

    patchTask(taskChanges, id, goalId, taskId).then((res: any) => {
      fetchGoals();
      setShowToast(true);
      setToastText("Return Task");
      setToastBody(task.name);
    });
  };

  const onClickDelete = () => {
    setIsDeleting(true);
    setTaskToDelete(task);
  };

  const onClickDeleteFinal = () => {
    if (!task.is_completed) {
      deleteTask(id, goalId, task?.id).then((res: any) => {
        fetchGoals();
        setShowToast(true);
        setToastText("Task Deleted");
        setToastBody(task.name);
      });
    }
  };

  const onClickCancelDelete = () => {
    setIsDeleting(false);
    setTaskToDelete(undefined);
  };

  const renderDelete = () => {
    return (
      <Row>
        <Col>
          <Stack direction="horizontal" gap={3}>
            <Stack style={{ justifyContent: "center" }} className="col-6">
              <Card.Subtitle>Delete - {taskToDelete?.name}?</Card.Subtitle>
            </Stack>
            <Button className="app-danger-color button" onClick={() => onClickDeleteFinal()}>
              Confirm Delete
            </Button>
            <div className="vr" />
            <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
              Cancel
            </Button>
          </Stack>
        </Col>
      </Row>
    );
  };

  return (
    <>
      {isDeleting ? (
        <>{renderDelete()}</>
      ) : (
        <Row>
          <Col className={task.is_cm_reviewed ? "text-decoration-line-through app-green-text" : ""}>{task.name}</Col>
          {inNextTasks === true && (
            <Col className="text-end">
              {task.is_completed && task.is_cm_reviewed !== 1 ? (
                <Badge className="app-tertiary-color-inverse mx-3" bg="none">
                  Needs Review
                </Badge>
              ) : (
                ""
              )}
              {task.age > 0 ? (
                <Badge className="app-tertiary-color-inverse me-3" bg="none">
                  {task.age} Day(s)
                </Badge>
              ) : (
                ""
              )}
            </Col>
          )}
          {inNextTasks !== true && (
            <Col className="text-end">
              {task.is_completed && task.is_cm_reviewed !== 1 ? (
                <>
                  <Badge className="me-3 app-tertiary-color" bg="none">
                    Needs Review
                  </Badge>

                  <FontAwesomeIcon
                    data-tooltip-id="tooltip-task-complete"
                    data-tooltip-content="Complete Task"
                    className={task.is_cm_reviewed ? "app-green-text cursor-pointer" : "text-muted me-3 cursor-pointer"}
                    icon={faCheckCircle}
                    onClick={() => handleCompletedClick(task.id)}
                  />
                  <Tooltip id="tooltip-task-complete" place="top" style={{ padding: "5px 10px", zIndex: "1100" }} />

                  <FontAwesomeIcon
                    data-tooltip-id="tooltip-task-return"
                    data-tooltip-content="Return Task"
                    className="text-muted cursor-pointer"
                    icon={faRefresh}
                    onClick={() => handleReturnClick(task.id)}
                  />
                  <Tooltip id="tooltip-task-return" place="top" style={{ padding: "5px 10px", zIndex: "1100" }} />
                </>
              ) : (
                myCase && (
                  <>
                    <FontAwesomeIcon
                      data-tooltip-id="tooltip-task-complete"
                      data-tooltip-content="Complete Task"
                      className={task.is_cm_reviewed ? "app-green-text cursor-pointer" : "text-muted me-3 cursor-pointer"}
                      icon={faCheckCircle}
                      onClick={() => handleCompletedClick(task.id)}
                    />
                    <Tooltip id="tooltip-task-complete" place="top" style={{ padding: "5px 10px", zIndex: "1100" }} />

                    {goalArchived !== 1 && goalCompleted !== 1 && task.is_cm_reviewed !== 1 && (
                      <>
                        <FontAwesomeIcon
                          data-tooltip-id="tooltip-task-next"
                          data-tooltip-content="Next Task"
                          className={next ? "app-orange-text me-3 cursor-pointer" : "text-muted me-3 cursor-pointer"}
                          icon={faStar}
                          onClick={() => handleNextClick(task.id)}
                        />
                        <Tooltip id="tooltip-task-next" place="top" style={{ padding: "5px 10px", zIndex: "1100" }} />

                        <FontAwesomeIcon
                          data-tooltip-id="tooltip-task-delete"
                          data-tooltip-content="Delete Task"
                          className={task.is_completed ? "text-muted" : "text-muted cursor-pointer"}
                          icon={faTrash}
                          onClick={() => onClickDelete()}
                        />
                        <Tooltip id="tooltip-task-delete" place="top" style={{ padding: "5px 10px", zIndex: "1100" }} />
                      </>
                    )}
                  </>
                )
              )}
            </Col>
          )}
        </Row>
      )}
    </>
  );
};

export default TaskItem;
